import { supabase } from '../../core/config/supabase';
import { logger } from '@/src/core/utils';
import {
  RpmLeaderboardEntryEntity,
  TrainingLaunchEntity,
  UserTrainingStatsEntity,
} from '../entities/TrainingLaunchEntity';
import { TrainingLaunch } from '../../domain/models/TrainingLaunch';
import { trainingLaunchModelToEntity } from '../entities/TrainingLaunchEntity';

export class TrainingDataSource {
  async insert(launch: TrainingLaunch): Promise<void> {
    const entity = trainingLaunchModelToEntity(launch);
    const { error } = await supabase.from('training_launches').insert(entity);
    if (error) {
      logger.error('TrainingDataSource', 'insert failed', { error });
      throw new Error(error.message);
    }
  }

  async getLeaderboard(sortBy: string = 'rpm', limit: number = 50): Promise<RpmLeaderboardEntryEntity[]> {
    const { data, error } = await supabase.rpc('get_leaderboard', {
      sort_by: sortBy,
      limit_count: limit,
    });
    if (error) {
      logger.error('TrainingDataSource', 'getLeaderboard failed', { error });
      throw new Error(error.message);
    }
    return (data ?? []) as RpmLeaderboardEntryEntity[];
  }

  async getUserTrainingStats(userId: string): Promise<UserTrainingStatsEntity | null> {
    const { data, error } = await supabase.rpc('get_user_training_stats', {
      target_user_id: userId,
    });
    if (error) {
      logger.error('TrainingDataSource', 'getUserTrainingStats failed', { error });
      throw new Error(error.message);
    }
    if (!data || data.length === 0) return null;
    return data[0] as UserTrainingStatsEntity;
  }

  async getUserLaunches(userId: string): Promise<TrainingLaunchEntity[]> {
    const { data, error } = await supabase
      .from('training_launches')
      .select('*')
      .eq('user_id', userId)
      .order('timestamp', { ascending: false });
    if (error) {
      logger.error('TrainingDataSource', 'getUserLaunches failed', { error });
      throw new Error(error.message);
    }
    return (data ?? []) as TrainingLaunchEntity[];
  }
}
